import { IGetSubscriptionsDTO } from '@/models/subscriptions.model';
import { SubscriptionsFiltersFields, TGetSubscriptionsQuery } from '@/modules/Subscriptions/helpers/types';

class SubscriptionsDTO implements IGetSubscriptionsDTO {
  email?: string;
  date_from?: string;
  date_to?: string;
  page?: number;
  per_page?: number;

  constructor(values: TGetSubscriptionsQuery & { page?: number }) {
    this.email = values[SubscriptionsFiltersFields.EMAIL];
    this.date_from = values[SubscriptionsFiltersFields.DATE_FROM];
    this.date_to = values[SubscriptionsFiltersFields.DATE_TO];
    this.page = values.page ?? 1;
    this.per_page = 10;
  }
}

export default SubscriptionsDTO;
